import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Alert from '../../utils/Alert';
import Spinner from '../../components/generics/Spinner';

import CreateShipment from '../../components/shipments/CreateShipment';

import {
  createShipment,
  createShipmentSuccess,
  createShipmentFailure,
  fetchDestinations,
  fetchDestinationsSuccess,
  fetchDestinationsFailure,
} from "../../store/shipments/actions";
import { withRouter } from "utils/WithRouter";

export class ShipmentNewContainer extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);

    this.state = {
      errors: [],
      selectedDestination: undefined
    };

    this.alertRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.destinationsList.destinations.length === 0) {
      this.props.fetchDestinations(this.alertRef);
    }
  }

  // ---------------------------------------------------------------------------
  // Shipment handling
  // ---------------------------------------------------------------------------
  onCreateShipment = () => {
    if (!this.state.selectedDestination){
      this.setState({errors: ['destination', ...this.state.errors]});
      this.alertRef.current.sendAlert('Destination is required!');
    } else {
      var newShipment = new FormData();
      newShipment.append('destination', parseInt(this.state.selectedDestination, 10));
      this.props.createShipment(newShipment, this.props, this.alertRef);
    }
  };

  onCancelShipment = () => {
    this.props.history.push('/shipment/');
  };

  onSelectDestination = (event) => {
    this.setState({selectedDestination: event.target.value, errors: []});
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
    if (this.props.destinationsList.loading || this.props.createEditShipment.loading){
      return (
        <div>
          <Alert ref={this.alertRef}/>
          <Spinner />
        </div>
      );
    } else {
      return (
        <Fragment>
          <Alert ref={this.alertRef}/>
          <CreateShipment
            destinations={this.props.destinationsList.destinations}
            errors={this.state.errors}
            createShipment={this.onCreateShipment}
            cancelShipment={this.onCancelShipment}
            onDestinationChange={this.onSelectDestination}
          />
        </Fragment>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    createEditShipment: state.shipments.createEditShipment,
    destinationsList: state.shipments.destinationsList
  };
};

const mapDispatchToProps = (dispatch) => {
  const finished = (data, props) => {
    props.history.push(`/shipment/${data.id}/edit`);
  }
  return {
    createShipment: (data, props, alertRef) => {
      dispatch(createShipment(data)).payload.then((response) => {
        dispatch(createShipmentSuccess(response.data));
        finished(response.data, props);
      }, (error) => {
        dispatch(createShipmentFailure(error));
        alertRef.current.sendAlert('Something went wrong');
      });
    },
    fetchDestinations: (alertRef) => {
      dispatch(fetchDestinations()).payload.then((response) => {
        dispatch(fetchDestinationsSuccess(response.data));
      }, (error) => {
        dispatch(fetchDestinationsFailure(error));
        alertRef.current.sendAlert('Something went wrong');
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShipmentNewContainer));
